import { FETCH_FOOTER_INFO_SUCCESS } from "./actionTypes";

const temp = [
    {
        path: `data:image/svg+xml;utf8,${encodeURIComponent(`
<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 100% 320"
  width="100%"
  height="320"
  preserveAspectRatio="none"
  style="display: block; border-radius: 8px;"
>
  <defs>
          <linearGradient id="shimmerGradient" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stop-color="#e0e0e0" />
            <stop offset="40%" stop-color="#e0e0e0" />
            <stop offset="50%" stop-color="#f5f5f5" />
            <stop offset="60%" stop-color="#e0e0e0" />
            <stop offset="100%" stop-color="#e0e0e0" />
          </linearGradient>
          <mask id="shimmerMask">
            <rect x="-400" y="0" width="100%" height="400" fill="url(#shimmerGradient)">
              <animateTransform attributeName="transform" type="translate" from="-1200 0" to="400 0" dur="2s" repeatCount="indefinite" />
            </rect>
          </mask>
        </defs>

  <!-- Image placeholder with shimmer animation -->
    <rect width="100%" height="500" fill="#f0f0f0" />
    <rect x="16" y="20" width="30%" height="30" rx="5" ry="5" fill="#e0e0e0" mask="url(#shimmerMask)" />
    <rect x="16" y="70" width="40%" height="20" rx="5" ry="5" fill="#e0e0e0" mask="url(#shimmerMask)" />
    <rect x="16" y="100" width="50%" height="20" rx="5" ry="5" fill="#e0e0e0" mask="url(#shimmerMask)" />
    <rect x="16" y="140" width="60%" height="20" rx="5" ry="5" fill="#e0e0e0" mask="url(#shimmerMask)" />
    <rect x="16" y="180" width="90%" height="20" rx="5" ry="5" fill="#e0e0e0" mask="url(#shimmerMask)" />
</svg>

            `)}`,
        loading: true,
        menu: {
            code: "home"
        }
    }
]

const initialState = {
    data: temp,
};

const footerInformationListR = (state = initialState, action) => {

    switch (action.type) {
        case FETCH_FOOTER_INFO_SUCCESS:
            console.log("Fetching media info from API. If delayed, default images will be used.");
            const updatedData = action.payload.response || temp;
            if (!action.payload.response) {
                console.log("API response delayed or unavailable. Loading default images.");
            }
            return { ...state, data: updatedData };
        default:
            return state;
    }
}

export default footerInformationListR